import { webApi, getCsrfToken } from "../api";

export const getSettings = async () => {
  const res = await webApi.get(`/settings`);
  return res.data;
};

export const saveSettings = async (payload: any) => {
  await getCsrfToken();
  const res = await webApi.put(`/settings`, payload);
  return res.data;
};

export default { getSettings, saveSettings };
